<template>
  <div class="repayment-table">
    <section>
      <div class="col-sm-4">
        <div class="btn-group-horizontal">
          <router-link
            :to="{ name: 'add-repayment', params: { loan_id: loanID, bid: borrowerID } }"
            class="btn bg-gray"
          >
            Add Repayment
          </router-link>
        </div>
      </div>
    </section>
    <section class="repayment">
      <div class="card card-outline mt-3 card-info">
        <div class="card-body">
          <table id="repaymentsTabTable" class="table table-striped">
            <thead class="table-custom-header">
              <tr>
                <th>Collection Date</th>
                <th>Collected By</th>
                <th>Method</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="repayment in repayments" :key="repayment.id">
                <td>{{ formatDate(repayment.collection_date) }}</td>
                <td>{{ repayment.collected_by }}</td>
                <td>{{ repayment.payment_method }}</td>
                <td>{{ formatNumber(repayment.amount_paid) }}</td>
                <td>
                  <router-link
                    class="btn bg-white btn-xs text-bold m-2 btn-a-color"
                    :to="{ name: 'edit-repayment', params: { loan_id: repayment.loan_id, bid: repayment.borrower_id, id: repayment.id } }"
                  >Edit</router-link>
                  <a class="btn bg-white btn-xs text-bold m-2 btn-a-color" @click="deleteUserRepayment(repayment.id)">Delete</a>
                </td>
              </tr>
            </tbody>
            <tfoot class="bg-gray">
              <tr>
                <td colspan="3"></td>
                <td><strong>{{ formatNumber(totalAmountPaid) }}</strong></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'loan-repayments-table',
  data() {
    return {
      repayments: []
    };
  },

  computed: {
    loanID() {
      return this.$route.params.id;
    },
    borrowerID() {
      return this.$route.params.bid;
    },
    totalAmountPaid() {
      return this.repayments.reduce((sum, row) => sum + parseFloat(row.amount_paid || 0), 0);
    }
  },

  watch: {
      repayments(val) {
          this.dt.destroy();
          this.$nextTick(()=> {
              this.dt = $('#repaymentsTabTable').DataTable()
              });
      },
  },
  
  methods: {
    fetchRepayments() {
      axios.get('api/repayment/getUser/' + this.loanID, {
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        this.dt = $('#repaymentsTabTable').DataTable();
        this.repayments = response.data;
      }).catch(err => {
        console.error('Failed to load repayments', err);
      });
    },

    deleteUserRepayment(id) {
      axios.delete('api/repayment/${id}/deleteRepayment')
        .then(response => {
          if (response.data.response === 'success') {
            this.repayments = this.repayments.filter(r => r.id !== id);
            this.$swal({
              type: 'success',
              title: 'Deleted',
              text: 'Repayment successfully removed.',
              timer: 3000
            });
          } else {
            this.$swal('Error', response.data.message, 'error');
          }
        }).catch(err => {
          console.error('Error deleting repayment:', err);
        });
    },

    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    }
  },

  created() {
    this.fetchRepayments();
  }
};
</script>
